<style lang="scss">
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.action-butn-resize-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
</style>
<template>
  <div id="page-user-edit">
    <div class="content">
      <section class="cropper-area">
        <div class="img-cropper">
          <vue-cropper
            ref="cropper"
            :aspect-ratio="aspectValue"
            :src="sourceImage"
            preview=".preview"
          />
        </div>
      </section>

      <section class="preview-area">
        <p class="text-center">Preview</p>
        <div id="image" class="preview mx-auto" />
        <p class="text-center mt-3">
          <v-btn color="primary" dark large @click="upload_photo"> Crop </v-btn>
        </p>
      </section>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <!-- <v-button class="ml-auto mt-2" @click="upload_photo"
            >Upload</v-button
          > -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

import { bus } from "@/main";
import APIs from "@/components/APIInit";
import axios from "axios";

export default {
  components: {
    VueCropper,
  },
  props: {
    aspectValue: {
      type: Number,
      required: true,
    },
    sourceImage: {
      type: String,
      required: true,
    },
    file: {
      type: Object,
      required: true,
    },
    uploadPath: {
      type: String,
      required: true,
    },
    clientId: {
      type: String,
      default: "",
    },
    eventId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      photowall_data: null,
      photowall_not_found: false,
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT_C1591904892446E1598284508652%2FPhotoWall%2FGeneral%2F1621962369375_405435%20-%20Copy.jpg?alt=media",
      cropImg: "",
      data: null,
      activeTab: 0,
    };
  },
  watch: {},
  methods: {
    upload_photo() {
      var self = this;
      bus.$emit("toggleLoader", true);
      let cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      let json = JSON.stringify(cropImg, null, 2);
      let blob = new Blob([json], { type: "image/png" });
        console.log("-----b---",blob);
        
      self.croppedImagePath(cropImg.toString());
      
//this.$emit("croppedImagePath", cropImg.toString());
      //this.$emit("croppedImagePath", cropImg.toString());
    },
    croppedImagePath(blob) {
      var self = this;
      console.log(blob);

      if (this.uploadPath) {
        self.uploadServerImage(blob, this.uploadPath, this.file);
      }
    },
    uploadServerImage(fileBlob, target, file) {
      var self = this;
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + self.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientId,
          eventId: self.eventId,
        },
        files: [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ],
      };
      axios
        .post(APIs.UploadFiles, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (
            res.data.status == 0 &&
            res.data.data.length &&
            res.data.data[0].status == "fulfilled"
          ) {
            self.$emit("uploadedImagePath", {
              Status: 200,
              Message: "Image Uploaded Succesfully",
              Path: res.data.data[0].value.url,
            });
          } else {
            self.$emit("uploadedImagePath", {
              Status: -1,
              Message: "Image Uploaded Failed",
              Path: null,
            });
          }
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          //vm.showSnackbar("Something went wrong!", "error", "top");

        });
    },
  },
  created() {
    console.log("imageFileDetails======", this.file);

    if (this.$route.params.row) {
      this.photowall_data = this.$route.params.row;
      this.imgSrc = this.$route.params.row.photoUrl;
    } else this.photowall_not_found = true;
  },
};
</script>

<style>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 5px 0;
}
.header h2 {
  margin: 0;
}
.header a {
  text-decoration: none;
  color: black;
}
.content {
  display: flex;
  justify-content: space-between;
}
.cropper-area {
  width: 614px;
  border: 1px solid #cbcbcb;
  margin-top: 50px;
}
.actions {
  margin-top: 1rem;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062cc;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
textarea {
  width: 100%;
  height: 100px;
}
.preview-area {
  width: 400px;
  margin-top: 41px;
  position: relative;
}
/* .preview-area:after {
    content: "";
    position: absolute;
    height: 100%;
    width: 1px;
    background: #cbcbcb;
    right: 100%;
    top: 0;
    margin-right: 21px;
} */
.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}
.preview-area1 p:last-of-type {
  margin-top: 1rem;
}
.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}
.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}
.cropped-image img {
  max-width: 100%;
}
</style>